module.exports = __webpack_public_path__ + "img/chevron-up.6477f047.svg";